import { createContext, useContext, useState, useCallback, useEffect } from "react";
import { api } from "../lib/api";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);

  const refresh = useCallback(async () => {
    const { data } = await api.get("/site");
    setSite(data);
  }, []);

  useEffect(() => {
    refresh().catch(() => setSite(false));
  }, [refresh]);

  return (
    <SiteContext.Provider value={{ site, refresh }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
